import { render, staticRenderFns } from "./cModalProcInvasivosNew.vue?vue&type=template&id=4c6c0b2e&scoped=true"
import script from "./cModalProcInvasivosNew.vue?vue&type=script&lang=js"
export * from "./cModalProcInvasivosNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6c0b2e",
  null
  
)

export default component.exports